import React, { useCallback } from 'react';
import cn from 'classnames';

import isNotFn from 'utils/predicates/function/isNotFn.util';

import CN from './ColorItem.module.scss';

const ColorItem = ({ color, isSelected, onClick }) => {
  const colorClasses = cn({
    [CN.component]: true,
    [CN.active]: isSelected,
  });

  const handleClick = useCallback(() => {
    if (isNotFn(onClick)) {
      return;
    }
    onClick(color);
  }, [color, onClick]);

  return <span data-bem="ColorPicker__item" className={colorClasses} onClick={handleClick} style={{ background: color }} role="button" tabIndex="0" />;
};

export default ColorItem;
